__turbopack_context__.v({
  "icon": "MobileMenuSearchInput-module__lehe_G__icon",
  "iconWrapper": "MobileMenuSearchInput-module__lehe_G__iconWrapper",
  "placeholder": "MobileMenuSearchInput-module__lehe_G__placeholder",
  "trigger": "MobileMenuSearchInput-module__lehe_G__trigger",
});
